import { MenuItem } from './menu.model';

export const INTERNALADMINMENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU',
    isTitle: true
  },
  {
    id:2,
    label: 'MENUITEMS.DASHBOARD',
    icon: 'ri-dashboard-2-line',
    link: ''
  },
  {
    id: 3,
    label: 'MENUITEMS.CLIENTS',
    icon: 'ri-folders-line',
    link: '/clients'
  },
  {
    id: 4,
    label: 'MENUITEMS.USERS',
    icon: 'ri-team-line',
    link: '/users'
  },
  {
    id: 5,
    label: 'MENUITEMS.RESEARCH_ADMINS',
    icon: 'ri-microscope-line',
    link: '/research-admins'
  },
	{
    id: 6,
    label: 'MENUITEMS.BASELINE',
    icon: 'ri-file-list-3-line',
    link: '/baselines'
  },
  // {
  //   id: 6,
  //   label: 'MENUITEMS.TEMPLATES',
  //   icon: 'ri-file-line',
  //   link: '/templates'
  // },
  // {
  //   id: 7,
  //   label: 'MENUITEMS.LISTS',
  //   icon: 'ri-list-unordered',
  //   link: '/lists'
  // }
];

export const INTERNALEDITORMENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU',
    isTitle: true
  },
  {
    id:2,
    label: 'MENUITEMS.DASHBOARD',
    icon: 'ri-dashboard-2-line',
    link: '/dashboard-editor'
  },
  {
    id: 3,
    label: 'MENUITEMS.REQUESTS',
    icon: 'ri-folders-line',
    link: '/request'
  }  
];

export const RESEARCHERMENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU',
    isTitle: true
  },
  {
    id: 2,
    label: 'MENUITEMS.DASHBOARD',
    icon: 'ri-dashboard-2-line',
    link: '/research/dashboard'
  },
  {
    id: 3,
    label: 'MENUITEMS.PROJECTS',
    icon: 'ri-folder-open-line',
    link: '/research/projects'
  }
];

export const RESEARCHERADMINMENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU',
    isTitle: true
  },
  {
    id: 2,
    label: 'MENUITEMS.DASHBOARD',
    icon: 'ri-dashboard-2-line',
    link: '/research/dashboard'
  },
  {
    id: 3,
    label: 'MENUITEMS.PROJECTS',
    icon: 'ri-folder-open-line',
    link: '/research/projects'
  },
  {
    id: 4,
    label: 'MENUITEMS.USERS',
    icon: 'ri-group-line',
    link: '/research/users'
  },
  {
    id: 5,
    label: 'MENUITEMS.CREATE.TEXT',
    icon: 'ri-folder-add-line',
    subItems: [
      {
        id: 6,
        label: 'MENUITEMS.CREATE.LIST.PROJECT',
        parentId: 5,
        icon: 'ri-folder-add-line',
        modal: 'researchProjectModal'
      }
    ]
  }
];
